import { WithholdingType } from "./withholding-type";

export class Withholding {

    id: number = 0;
    description!: string;
    withholdingType: WithholdingType = new WithholdingType();
    attribute!: string;
    active: boolean = false;
} 